export const GET_FEEDBACKLIST_DATA = 'feedbackList/GET_FEEDBACKLIST_DATA'
export const GET_FEEDBACKLIST_TOTAL = 'feedbackList/GET_FEEDBACKLIST_TOTAL'
export const SET_INPUT_VALUE = 'feedbackList/SET_INPUT_VALUE'
export const SET_CURRENT = 'feedbackList/SET_CURRENT'